import { render, staticRenderFns } from "./AppBadgeIcon.vue?vue&type=template&id=4de1370c&scoped=true"
import script from "./AppBadgeIcon.vue?vue&type=script&lang=js"
export * from "./AppBadgeIcon.vue?vue&type=script&lang=js"
import style0 from "./AppBadgeIcon.vue?vue&type=style&index=0&id=4de1370c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de1370c",
  null
  
)

export default component.exports